import { type FC, useCallback, type MouseEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import dibsCss from 'dibs-css';
import { Link } from 'dibs-elements/exports/Link';
import { trackEvent } from 'dibs-tracking';
import { handleLocaleUrl } from 'dibs-intl/exports/urls';
import classnames from 'classnames';

export const PdpSharedBuyerIncentivesLink: FC<{ isPDPDesktopAggregationVariant?: boolean }> = ({
    isPDPDesktopAggregationVariant,
}) => {
    const intl = useIntl();

    const incentivesLinkClick: MouseEventHandler = useCallback(event => {
        trackEvent(
            {
                category: 'product',
                action: 'Learn More Click',
                label: 'pdp description | 1stDibs Promise',
            },
            event
        );
    }, []);

    return (
        <Link
            href={handleLocaleUrl('/about/promise/', intl.locale)}
            target="_blank"
            onClick={incentivesLinkClick}
            className={classnames({
                [dibsCss.sassyFontBodyMedium]: !isPDPDesktopAggregationVariant,
                [dibsCss.sassyFontBodySmall]: isPDPDesktopAggregationVariant,
            })}
        >
            <FormattedMessage
                id="PdpSharedBuyerIncentivesLink.learnMore"
                defaultMessage="Learn More"
            />
        </Link>
    );
};
